import * as CookieConsent from 'vanilla-cookieconsent';
import { gsap, CustomEase } from '../../global/gsap';

const initSplash = (element) => {
    const siteButtons = document.querySelector('.site-buttons');
    const heroFeatured = document.querySelector('.home-banner__featured');

    const splashPlayed = sessionStorage.getItem('splashShown');

    if (splashPlayed) {
        gsap.set(element, {
            display: 'none'
        });

        gsap.set([siteButtons, heroFeatured], {
            opacity: 1
        });
    } else {
        gsap.set([siteButtons, heroFeatured], {
            opacity: 0,
            x: '25%'
        });

        const tl = gsap.timeline({
            onStart: () => {
                window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
                document.body.classList.add('stop-scrolling');
            },
            onComplete: () => {
                gsap.to([siteButtons, heroFeatured], {
                    opacity: 1,
                    x: 0,
                    stagger: 0.25,
                    onComplete: () => {
                        document.body.classList.remove('stop-scrolling');
                        sessionStorage.setItem('splashShown', true);

                        // Check if cookie manager hasn't been responded to
                        if (!document.cookie.split(';').some((item) => item.trim().startsWith('cc_cookie='))) {
                            CookieConsent.show();
                        }
                    }
                });
            }
        });

        tl.addLabel('start');

        tl.to(element, {
            clipPath: 'inset(0 0 100% 0)',
            duration: 1.5,
            delay: 0.75,
            ease: CustomEase.create('custom', '0.22, 1, 0.36, 1')
        }, 'start');
    }
};

export { initSplash as default };
